<template lang="pug">
.calendar_body
  template(v-if="rowCount > 0" )
    CalendarRow(
      v-for='(row, index) in rowCount',
      :data='data',
      :row-count='index',
      :key='index',
      :days='days'
    )
  .empty_data(v-else) ЗАНЯТИЙ НА ЭТОЙ НЕДЕЛЕ НЕТ
</template>

<script>
import CalendarRow from './CalendarRow';
export default {
  name: 'CalendarBody',
  components: { CalendarRow },
  props: {
    data: {},
    days: {},
  },
  computed: {
    rowCount() {
      let maxRows = 0;
      Object.values(this.data).forEach((el) => {
        maxRows = el.length > maxRows ? el.length : maxRows;
      });
      return maxRows;
    },
  },
};
</script>

<style scoped lang="stylus">
.empty_data
  color: #afabab;
  font-size: 14px;
  text-transform: uppercase;
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #aaa;
  border-right: 1px solid #aaa;
.calendar_body
  font-family: 'Open Sans', sans-serif;
  background: white;
  display flex;
  flex-direction column;
  border-left 1px solid #aaaaaa
</style>



// WEBPACK FOOTER //
// CalendarBody.vue?1f122931